export default import.meta.ROLLDOWN_FILE_URL_hpFJm35QgUQDOqEpwO7D$w